import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  display: flex;
  flex-direction: ${props => props.layout === 'vertical' ? 'column' : 'row'};
  gap: 10px;
  justify-content: ${props => props.align || 'center'};
  align-items: center;
  width: ${props => props.width || '100%'};
  
  @media(max-width: 600px) {
    flex-direction: column;
  }
`;

const Input = styled.input`
  flex: 1;
  min-width: 200px;
  padding: 12px 16px;
  border-radius: 30px;
  border: 1px solid var(--glass-border);
  background: var(--glass-1);
  color: var(--text-primary);
  outline: none;
  backdrop-filter: blur(8px);
  
  &:focus {
    border-color: var(--accent);
  }
`;

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 30px;
  background: linear-gradient(135deg, var(--accent), var(--accent-neon));
  color: #fff;
  font-weight: 600;
  border: none;
  cursor: pointer;
  white-space: nowrap;
`;

const NewsletterWidget = ({ node }) => {
  const btnText = node.content?.btnText || 'Abonnieren';
  const placeholder = node.content?.placeholder || 'Deine E-Mail Adresse';
  const layout = node.style?.desktop?.layout || 'horizontal';
  const align = node.style?.desktop?.align || 'center';

  return (
    <Wrapper layout={layout} align={align}>
      <Input type="email" placeholder={placeholder} />
      <Button className="tef-bubbles">{btnText}</Button>
    </Wrapper>
  );
};

registry.register('newsletter_form', {
  label: 'Newsletter Input',
  icon: '📰',
  category: 'forms',
  defaultContent: { placeholder: 'E-Mail eingeben...', btnText: 'Abonnieren' },
  defaultStyle: { desktop: { layout: 'horizontal', align: 'center' } },
  render: NewsletterWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Texte', fields: [{name:'content.placeholder', label:'Platzhalter', type:'text'}, {name:'content.btnText', label:'Button Text', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Design', fields: [{name:'style.desktop.layout', label:'Layout', type:'select', options:[{label:'Nebeneinander', value:'horizontal'}, {label:'Unterteinander', value:'vertical'}]}, {name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Links', value:'flex-start'}, {label:'Zentriert', value:'center'}]}] }] }
  ]
});
